import { render, staticRenderFns } from "./NewsHxc.vue?vue&type=template&id=d5f4d742"
import script from "./NewsHxc.vue?vue&type=script&lang=ts"
export * from "./NewsHxc.vue?vue&type=script&lang=ts"
import style0 from "./NewsHxc.vue?vue&type=style&index=0&id=d5f4d742&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports